export const userCompletesPupForm = pet => ({
  type: 'Completes Pup Info',
  data: {
    flow: 'weight_web_acquisition',
    weight: pet.weight,
    activity_level: pet.activity,
    spay_status: pet.spayedStatus,
  },
});

export const viewPupInfoPageEvent = () => ({
  type: 'View Pup Info Page',
  data: {
    flow: 'weight_web_acquisition',
  },
});
